var React = require('react');

function CheckOvo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.25625 17.1217L5.05625 12.9217L3.65625 14.3217L9.25625 19.9217L21.2563 7.92173L19.8563 6.52173L9.25625 17.1217Z","fill":"#0A9828"}));
}

CheckOvo.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = CheckOvo;

CheckOvo.default = CheckOvo;
